import Tooltip from "components/tooltip/tooltip.component";
import { ICareerItem } from "../../interfaces/CareerInterface";

// Tailwind purges classes built from string interpolation. Map the prop
// explicitly so adding a new fontSize value requires updating this map AND
// guarantees the class string is literal in source.
const FONT_SIZE_CLASS_MAP: Record<string, string> = {
  "body-sm-emphasis": "text-body-sm-emphasis",
  "body-lg-emphasis": "text-body-lg-emphasis",
};

const CareerItem: React.FC<ICareerItem> = ({
  name,
  icon_url,
  id,
  pressed,
  showRanking,
  rank,
  isAdmin,
  showStatus = false,
  statusText,
  height,
  width,
  imagePadding,
  containerHeight = 160,
  containerWidth = 120,
  fontSize,
}: ICareerItem) => {
  return (
    <div
      id={id}
      style={{
        height: `${containerHeight}px`,
        width: `${containerWidth}px`,
        transition: 'width 0.3s ease, height 0.3s ease',
      }}
      className="relative flex flex-col items-center justify-start gap-3 rounded-xl p-4 pt-3 text-center select-none cursor-pointer bg-brand"
      onClick={(e: React.MouseEvent<HTMLDivElement>) => pressed(id)}
      onContextMenu={() => false}
    >
      {showRanking && (
        <span
          className={`absolute -top-2 -left-2 rounded-full bg-chart_gold w-[26px] h-[26px] text-center font-sans text-xs font-semibold leading-4 tracking-normal text-text-heading content-center border-2 border-white`}
        >
          {rank}
        </span>
      )}
      <div className={`shrink-0 ${imagePadding || ""}`}>
        <div
          className="rounded-full overflow-hidden bg-white"
          style={{
            width: `${width || 72}px`,
            height: `${height || 72}px`,
            border: '1px solid #E8E8E8',
          }}
        >
          <img
            className="w-full h-full object-cover pointer-events-none"
            src={icon_url}
            alt={name}
          />
        </div>
      </div>
      <Tooltip
        content={name}
        placement="top"
        placing="0px"
        customClass="max-w-[100px]"
      >
        <span
          className={`text-white font-sans text-xs font-semibold leading-4 tracking-normal text-center line-clamp-2 break-words ${
            fontSize ? FONT_SIZE_CLASS_MAP[fontSize] ?? "" : ""
          }`}
        >
          {name}
        </span>
      </Tooltip>
      {showStatus && (() => {
        const status = String(statusText).toLowerCase()
        const colorClass =
          status === "complete"
            ? "bg-action text-white"
            : status === "in progress"
              ? "bg-[#D4B07D] text-[#303030]"
              : "bg-[#E8E8E8] text-[#303030]"
        const borderStyle =
          status === "in progress" || status === "complete"
            ? { border: '1px solid #E8E8E8' }
            : {}
        return (
          <span
            style={borderStyle}
            className={`absolute -bottom-3 left-1/2 -translate-x-1/2 text-xs font-semibold px-2.5 py-0.5 rounded-md whitespace-nowrap shadow-sm flex items-center justify-center ${colorClass}`}
          >
            {statusText}
          </span>
        )
      })()}
    </div>
  );
};

export default CareerItem;
